<template>
	<core-layout-content full>
		<div class="flex xs-12">
			<div class="xs-7 p2">
				<apeiron-case-checklist class="mt2" />
			</div>
			<div class="xs-5 pl4">
				<apeiron-case-status class="mt4" />
				<apeiron-case-actions class="mt4" />
			</div>
		</div>
	</core-layout-content>
</template>

<script>
import ApeironCaseStatus from "./ApeironCaseStatus"
import ApeironCaseActions from "./ApeironCaseActions"
import CoreLayoutContent from "@/modules/core/components/CoreLayoutContent"
import ApeironCaseChecklist from "./ApeironCaseChecklist"

export default {
	components: {
		ApeironCaseStatus,
		ApeironCaseActions,
		ApeironCaseChecklist,
		CoreLayoutContent
	}
}
</script>
